module.exports = {
  localStorageKey: 'lc_pref',
  fallbackLocale: 'en',
};
